import type { GlobalImport } from '../shared/interfaces';

import { FormWidgetBase } from './shared/form-widget-base';
import { getUtmTagsToMetadata } from './shared/get-utm-tags-to-metadata';
import { recaptchaReady } from './shared/recaptcha-ready';
import { requestWithRecaptchaV3 } from './shared/request';
import { accountInfoLabels } from './shared/selectors';

class RedirectProspectWidget extends FormWidgetBase {
    override requiredImports: GlobalImport[] = [`recaptchaV3`];
    override requiredInfo = [...accountInfoLabels];

    async submit(info: any) {
        const custom_fields = [
            {
                name: `metadata`,
                value: JSON.stringify(getUtmTagsToMetadata()),
            },
        ];

        const body = {
            custom_fields,
            email: info.email,
            first_name: info.first_name,
            last_name: info.last_name,
        };

        await recaptchaReady();
        const accountResponse = await requestWithRecaptchaV3({
            apiUrl: window.mh.apiUrl,
            data: body,
            endpoint: `/v1/programs/${window.mh.programSlug}/accounts`,
            method: `POST`,
            recaptchaV3SiteKey: this.publicConfig.integrations.recaptchaV3.siteKey,
        });

        let account = await accountResponse.json();

        if (!accountResponse.ok) {
            // If account already exists we ignore that.
            if (account.error.message !== `Code has already been taken`) {
                throw new Error(account.error.message);
            }

            // Try updating account details. Should succeed, if account has no subscriptions.
            const updateAccountResponse = await requestWithRecaptchaV3({
                apiUrl: window.mh.apiUrl,
                data: body,
                endpoint: `/v1/programs/${window.mh.programSlug}/accounts/code-${account.user_id}`,
                method: `PUT`,
                recaptchaV3SiteKey: this.publicConfig.integrations.recaptchaV3.siteKey,
            });

            account = await updateAccountResponse.json();
            if (account.error) {
                throw new Error(account.error.message ?? account.error);
            }
        }

        const urlParams = new URLSearchParams(window.location.search);

        Object.entries(this.elements).forEach(([fieldName, element]) => {
            if (element.input) {
                urlParams.set(`mh-${fieldName}`, element.input.value);
            }
        });

        if (`url` in this.config) {
            window.location.href = `${this.config.url}?${urlParams}`;
        }
    }
}

customElements.define(`mh-redirect-prospect`, RedirectProspectWidget);

export default RedirectProspectWidget;
